import React, { useState, useMemo } from "react";
import AceEditor from "react-ace";
import _ from "lodash";

import "ace-builds/src-noconflict/mode-python";
import "ace-builds/src-noconflict/theme-xcode";

import styles from "./code.module.scss"

interface CodeEditorProps {
  pythonCode: string;
  name: string;
  aggregationCode: string;
}

const constructCode = (
  name: string,
  aggregationCode: string,
  pythonCode: string
): string => {
  const cleanedPythonCode = pythonCode.replace(/^\s*import\s+pandas\s+as\s+pd\s*/m, "");

  return `
from pymongo import MongoClient
import pandas as pd

# Connect to MongoDB
mongo_client = MongoClient(MONGO_URI)
db = mongo_client["data-seek"]
collection = db["${name}"]

# Run aggregation and create DataFrame
result = collection.aggregate(${aggregationCode})
df = pd.DataFrame(list(result))

${cleanedPythonCode.trim()}
`;
};


const CodeEditor: React.FC<CodeEditorProps> = ({
  pythonCode,
  name,
  aggregationCode,
}) => {
  const [copied, setCopied] = useState(false);

  const handleCopy = () => {
    navigator.clipboard.writeText(code);
    setCopied(true);
    setTimeout(() => setCopied(false), 2000);
  };

  const code = useMemo(
    () => constructCode(name, aggregationCode, pythonCode),
    [name, aggregationCode, pythonCode]
  );

  return (
    <div className={styles.container}>
      <div
        className={styles.headerContainer}
      >
        <span className={styles.codeType}>Python</span>
        <button
          onClick={handleCopy}
          className={styles.copyButton}
        >
          <img src={`${process.env.IMAGE_CDN_URL}/images/seek/copy.svg`} />
        </button>
      </div>

      <AceEditor
        mode="python"
        theme="xcode"
        name="code-editor"
        value={code}
        width="100%"
        height="150px"
        showGutter={false}
        readOnly={true}
        highlightActiveLine={false}
        showPrintMargin={false}
        editorProps={{ $blockScrolling: true }}
        setOptions={{
          showLineNumbers: true,
          tabSize: 2,
          wrap: false,
        }}
        className={styles.editor}
      />
    </div>
  );
};

export default CodeEditor;